import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";
import { PatientMedicalItemsHelper } from "@/Patient/Helpers/PatientMedicalItemsHelper";
import { MedicationModel } from "@/Patient/Models/Medication/MedicationModel";
import { PatientStore } from "@/Patient/Stores/PatientStore";

class PatientMedicationTabHandler extends BaseOperationHandler {
    constructor() {
        super();

        this.RegisterOperation(LocalPatientOperations.MedicationTab.UpdateMedicationPopup_Open, this.updateMedicationPopup_Open);
        this.RegisterOperation(LocalPatientOperations.MedicationTab.UpdateMedicationPopup_Close, this.updateMedicationPopup_Close);
        this.RegisterOperation(LocalPatientOperations.MedicationTab.UpdateMedicationPopup_Save, this.updateMedicationPopup_Save);
        this.RegisterOperation(LocalPatientOperations.MedicationTab.SearchPrescriptionTextBoxChange, this.searchPrescriptionTextBoxChange);
        this.RegisterOperation(LocalPatientOperations.MedicationTab.VigilanceAnalysis, this.vigilanceAnalysis);
    }

    private vigilanceAnalysis(request: LocalEvent): void {
        patientStore.ActionsPrescriptionTab.GetVigilanceAnalysis(request.PatientId, [], []);
    }

    private searchPrescriptionTextBoxChange(request: LocalEvent): void {
        let text = request.Get<string>("value");

        patientStore.PatientMedicationTabModels[request.PatientId] = patientStore.PatientMedicationTabModels[request.PatientId].set("SearchPrescriptionTextBox", text);
    }

    private updateMedicationPopup_Close(request: LocalEvent): void {
        patientStore.PatientMedicationTabModels[request.PatientId] = patientStore.PatientMedicationTabModels[request.PatientId].set("ShowUpdateMedicationPopup", false);
    }

    private updateMedicationPopup_Open(request: LocalEvent): void {
        let medication = request.Get<MedicationModel>("item");

        var clonedMedication;
        if (medication != null) {
            var medicationClone = JSON.parse(JSON.stringify(medication.Model));
            medicationClone.Dosages = Immutable.List(medicationClone.Dosages); // Recreate immutables after cloning
            clonedMedication = new MedicationModel(medicationClone);
        }
        else {
            clonedMedication = MedicationModel.FromDefaultModel(true, true);
        }

        patientStore.PatientMedicationTabModels[request.PatientId] = patientStore.PatientMedicationTabModels[request.PatientId]
            .set("MedicationModel", clonedMedication)
            .set("ShowUpdateMedicationPopup", true);
    }

    private async updateMedicationPopup_Save(request: LocalEvent, store: PatientStore): Promise<void> {
        patientStore.PatientMedicationTabModels[request.PatientId] = patientStore.PatientMedicationTabModels[request.PatientId]
            .set("ShowUpdateMedicationPopup", false)
            .set("MedicationModel", null);

        const baseMedicationUpdate = request.Get<MedicationModel>("baseMedicationItem");
        const newMedication = request.Get<MedicationModel>("newMedicationItem");
        const medications = [baseMedicationUpdate, newMedication];
        let encounterId = store.PatientUIModels[request.PatientId].get("EditEncounterIdContext");

        if (!encounterId && cacheStore.ClinicSettings.EnableDirectPatientProfileEdits) {
            store.IsMedicalItemFromOutsideNote = true;
            encounterId = await PatientMedicalItemsHelper.setOutsideNoteEncounter();
        }

        store.ActionsMedicationTab.UpsertMedication(medications, request.PatientId, encounterId);
    }
}

export { PatientMedicationTabHandler };
